"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mountIsland_1 = require("../../mountIsland");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var Toast_1 = __importStar(require("../../Generic/Toast"));
var Lang_js_1 = require("../../Lang.js");
var NAVY = '#1c1c3c';
var STATUS_CONFIG = {
    queued: { label: 'Queued', color: '#5b4a00', bg: 'rgba(245,200,11,0.16)' },
    running: { label: 'Running', color: '#0b4a92', bg: 'rgba(11,116,245,0.12)' },
    completed: { label: 'Completed', color: '#1a6e1e', bg: 'rgba(25,148,32,0.10)' },
    failed: { label: 'Failed', color: '#a11212', bg: 'rgba(200,18,18,0.10)' },
};
// Which inputs each sync type accepts. Mirrors BrightcoveSyncService::runAction:
// playlists/refs ignore `since`; refs has no `fast` concept.
var TYPE_FIELDS = {
    videos: { since: true, fast: true },
    tags: { since: true, fast: true },
    playlists: { since: false, fast: true },
    refs: { since: false, fast: false },
};
var TYPE_INFO = {
    videos: {
        summary: 'Additive download of new/changed videos. Leave "since" blank for a full pass (also pulls playlists + tags), or scope it (e.g. "now -1 hour").',
        downloads: 'Video records — windowed: only changed in the window; blank/"all": all videos + playlists + tags.',
        writesBack: 'Windowed run only: reference_id for just-downloaded videos missing one (gated). Blank/"all": nothing.',
        deletes: 'Nothing — additive download, never deletes.',
    },
    tags: {
        summary: 'Re-syncs tag→video associations. Blank/"all" does a full reconcile (with deletes); a window is additive only.',
        downloads: 'Videos + their tags, to rebuild the tag list and the brightcove_videos_tags pivot.',
        writesBack: 'Nothing.',
        deletes: 'Blank/"all": tags absent from Brightcove + stale/orphan pivot rows. Windowed: nothing.',
    },
    playlists: {
        summary: 'Reconciles playlists: deletes ones removed in Brightcove, downloads the rest, then pushes playlist refs.',
        downloads: 'All SVOD playlists and their members.',
        writesBack: 'reference_id for playlists missing one (gated).',
        deletes: 'Local playlists absent from Brightcove (cascades members); aborts if >25% would be removed.',
    },
    refs: {
        summary: 'Reconciles uniqid → Brightcove reference_id so every video/playlist is reachable. Writes to the shared Brightcove account.',
        downloads: 'Current reference_id of every video + playlist (to skip ones already canonical).',
        writesBack: 'reference_id for every video + playlist whose stored uniqid differs (idempotent; gated).',
        deletes: 'Nothing.',
    },
};
var DEFAULT_TYPE_INFO = { summary: '', downloads: '—', writesBack: '—', deletes: '—' };
var DataFlowTooltip = function (_a) {
    var info = _a.info;
    return (react_1.default.createElement(Box_1.default, { sx: { fontSize: '12px', lineHeight: 1.5, py: 0.25 } },
        react_1.default.createElement(Box_1.default, { sx: { mb: 0.5 } },
            react_1.default.createElement(Box_1.default, { component: "span", sx: { fontWeight: 700 } }, "Downloads:"),
            " ",
            info.downloads),
        react_1.default.createElement(Box_1.default, { sx: { mb: 0.5 } },
            react_1.default.createElement(Box_1.default, { component: "span", sx: { fontWeight: 700 } }, "Writes back:"),
            " ",
            info.writesBack),
        react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(Box_1.default, { component: "span", sx: { fontWeight: 700 } }, "Deletes:"),
            " ",
            info.deletes)));
};
function formatDuration(seconds) {
    if (seconds === null || seconds === undefined)
        return '—';
    if (seconds < 60)
        return "".concat(seconds, "s");
    var m = Math.floor(seconds / 60);
    var s = seconds % 60;
    return "".concat(m, "m ").concat(s, "s");
}
var StatusBadge = function (_a) {
    var _b;
    var status = _a.status;
    var cfg = (_b = STATUS_CONFIG[status]) !== null && _b !== void 0 ? _b : STATUS_CONFIG.queued;
    var active = status === 'queued' || status === 'running';
    return (react_1.default.createElement(Box_1.default, { sx: {
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            px: '10px', py: '3px', borderRadius: '12px',
            backgroundColor: cfg.bg, color: cfg.color,
            fontSize: '12px', fontWeight: 700, whiteSpace: 'nowrap',
        } },
        active
            ? react_1.default.createElement(CircularProgress_1.default, { size: 9, thickness: 6, sx: { color: cfg.color } })
            : react_1.default.createElement(Box_1.default, { sx: { width: '6px', height: '6px', borderRadius: '50%', backgroundColor: cfg.color, flexShrink: 0 } }),
        cfg.label));
};
var TriggerCard = function (_a) {
    var _b, _c;
    var syncType = _a.syncType, form = _a.form, busy = _a.busy, onChange = _a.onChange, onRun = _a.onRun;
    var fields = (_b = TYPE_FIELDS[syncType.type]) !== null && _b !== void 0 ? _b : { since: true, fast: true };
    var info = (_c = TYPE_INFO[syncType.type]) !== null && _c !== void 0 ? _c : DEFAULT_TYPE_INFO;
    return (react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
            p: '18px 20px', borderRadius: 2, backgroundColor: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.07)', flex: '1 1 240px', minWidth: 240,
            display: 'flex', flexDirection: 'column', gap: 1.25,
        } },
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', alignItems: 'center', gap: 0.75 } },
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '16px', fontWeight: 700, color: NAVY } }, syncType.label),
            react_1.default.createElement(Tooltip_1.default, { arrow: true, placement: "top", title: react_1.default.createElement(DataFlowTooltip, { info: info }) },
                react_1.default.createElement(Box_1.default, { component: "span", tabIndex: 0, "aria-label": (0, Lang_js_1.__)('What this sync downloads, writes back, and deletes'), sx: {
                        cursor: 'help', color: '#9a9ab0', fontSize: '14px', fontWeight: 700,
                        lineHeight: 1, userSelect: 'none', '&:hover': { color: NAVY },
                    } }, "\u24D8"))),
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#666', lineHeight: 1.4, minHeight: 50 } }, info.summary),
        fields.since && (react_1.default.createElement(TextField_1.default, { size: "small", label: (0, Lang_js_1.__)('Since'), placeholder: "all", value: form.since, onChange: function (e) { return onChange({ since: e.target.value }); }, InputLabelProps: { shrink: true } })),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexDirection: 'column' } },
            fields.fast && (react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { size: "small", checked: form.fast, onChange: function (e) { return onChange({ fast: e.target.checked }); } }), label: react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px' } }, (0, Lang_js_1.__)('Fast (larger batches)')) })),
            react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { size: "small", checked: form.pushRefs, onChange: function (e) { return onChange({ pushRefs: e.target.checked }); } }), label: react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px' } }, (0, Lang_js_1.__)('Push reference IDs (non-prod only)')) }),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '11px', color: '#a06a00', ml: '32px', mt: '-4px', lineHeight: 1.3 } }, (0, Lang_js_1.__)('Patches the shared Brightcove account — a non-prod push writes production data.'))),
        react_1.default.createElement(Button_1.default, { variant: "contained", disabled: busy, onClick: onRun, sx: { backgroundColor: NAVY, textTransform: 'none', fontWeight: 600, '&:hover': { backgroundColor: '#2a2a4c' } } }, busy ? (0, Lang_js_1.__)('Queuing…') : (0, Lang_js_1.__)('Run sync'))));
};
var RunRow = function (_a) {
    var run = _a.run, expanded = _a.expanded, onToggle = _a.onToggle;
    return (react_1.default.createElement(Box_1.default, { sx: { borderTop: '1px solid #eee' } },
        react_1.default.createElement(Box_1.default, { onClick: onToggle, sx: {
                display: 'grid',
                gridTemplateColumns: '120px 110px 1fr 90px 130px 30px',
                alignItems: 'center', gap: 1, px: 1, py: '10px', cursor: 'pointer',
                '&:hover': { backgroundColor: '#fafafa' },
            } },
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', fontWeight: 600, color: NAVY } },
                run.type_label,
                run.since ? react_1.default.createElement(Box_1.default, { component: "span", sx: { color: '#999', fontWeight: 400 } },
                    " \u00B7 ",
                    run.since) : null,
                run.fast ? react_1.default.createElement(Box_1.default, { component: "span", sx: { color: '#999', fontWeight: 400 } }, " \u00B7 fast") : null),
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(StatusBadge, { status: run.status })),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#777', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, run.error ? react_1.default.createElement(Box_1.default, { component: "span", sx: { color: '#a11212' } }, run.error) : (run.triggered_by || '—')),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#777' } }, formatDuration(run.duration)),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#777' } }, run.started_at || run.created_at || '—'),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#aaa', textAlign: 'center' } }, expanded ? '▾' : '▸')),
        expanded && (react_1.default.createElement(Box_1.default, { sx: { px: 1, pb: 1.5 } },
            react_1.default.createElement(Box_1.default, { component: "pre", sx: {
                    m: 0, p: 1.5, borderRadius: 1, backgroundColor: '#0e0e1a', color: '#d6d6e0',
                    fontSize: '12px', fontFamily: 'Menlo, Consolas, monospace', lineHeight: 1.5,
                    maxHeight: 360, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                } }, run.output && run.output.trim().length ? run.output : (0, Lang_js_1.__)('No output yet…'))))));
};
var BrightcoveSyncPanel = function () {
    var bootstrapEl = document.getElementById('msia-admin-brightcove-sync-bootstrap');
    var initialRuns = [];
    var types = [];
    try {
        var d = bootstrapEl ? JSON.parse(bootstrapEl.textContent || '{}') : {};
        initialRuns = d.runs || [];
        types = d.types || [];
    }
    catch (e) {
        console.warn('BrightcoveSyncPanel: parse error', e);
    }
    var _a = (0, react_1.useState)(initialRuns), runs = _a[0], setRuns = _a[1];
    var _b = (0, react_1.useState)(function () {
        return Object.fromEntries(types.map(function (t) { return [t.type, { since: '', fast: false, pushRefs: false }]; }));
    }), forms = _b[0], setForms = _b[1];
    var _c = (0, react_1.useState)(null), busyType = _c[0], setBusyType = _c[1];
    var _d = (0, react_1.useState)(null), expandedId = _d[0], setExpandedId = _d[1];
    var activeExists = runs.some(function (r) { return r.status === 'queued' || r.status === 'running'; });
    var refreshRuns = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, json, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch('/api/v2/twi/admin/sync/runs', {
                            credentials: 'same-origin',
                            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = _a.sent();
                    if (res.ok && Array.isArray(json.runs))
                        setRuns(json.runs);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    // Poll while any run is active; stop once everything has settled. Matched to
    // the service's ~1.5s output flush so streamed output appears near-live rather
    // than lagging a multi-second cycle behind.
    (0, react_1.useEffect)(function () {
        if (!activeExists)
            return;
        var t = setInterval(refreshRuns, 1500);
        return function () { return clearInterval(t); };
    }, [activeExists, refreshRuns]);
    var patchForm = function (type, patch) {
        return setForms(function (prev) {
            var _a;
            var _b;
            return (__assign(__assign({}, prev), (_a = {}, _a[type] = __assign(__assign({}, ((_b = prev[type]) !== null && _b !== void 0 ? _b : { since: '', fast: false, pushRefs: false })), patch), _a)));
        });
    };
    var trigger = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var f, res, json_1, e_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    f = (_a = forms[type]) !== null && _a !== void 0 ? _a : { since: '', fast: false, pushRefs: false };
                    setBusyType(type);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch('/api/v2/twi/admin/sync', {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                            body: JSON.stringify({ type: type, since: f.since || null, fast: !!f.fast, push_refs: !!f.pushRefs }),
                        })];
                case 2:
                    res = _d.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    json_1 = _d.sent();
                    if (!res.ok) {
                        (0, Toast_1.toast)({ message: json_1.message || (0, Lang_js_1.__)('Could not queue the sync.'), severity: 'error', autoHideMs: 6000 });
                    }
                    else {
                        (0, Toast_1.toast)({ message: json_1.message || (0, Lang_js_1.__)('Sync queued.'), severity: 'success' });
                        if (json_1.run)
                            setRuns(function (prev) { return __spreadArray([json_1.run], prev.filter(function (r) { return r.id !== json_1.run.id; }), true); });
                        setExpandedId((_c = (_b = json_1.run) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    e_2 = _d.sent();
                    (0, Toast_1.toast)({ message: (0, Lang_js_1.__)('Network error queuing the sync.'), severity: 'error', autoHideMs: 6000 });
                    return [3 /*break*/, 6];
                case 5:
                    setBusyType(null);
                    // Reconcile with the server even if the POST errored: a run row may have
                    // been created (e.g. a slow inline run timed out the response) and should
                    // still surface in the list rather than vanish until the next reload.
                    refreshRuns();
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(Box_1.default, { sx: { py: 3 } },
        react_1.default.createElement(Toast_1.default, null),
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '24px', fontWeight: 800, color: NAVY, mb: 0.5 } }, (0, Lang_js_1.__)('TWI Sync')),
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#666', mb: 2.5 } }, (0, Lang_js_1.__)('Trigger and monitor Brightcove → database syncs. Runs queue and process in the background; this panel updates automatically.')),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3.5 } }, types.map(function (t) {
            var _a;
            return (react_1.default.createElement(TriggerCard, { key: t.type, syncType: t, form: (_a = forms[t.type]) !== null && _a !== void 0 ? _a : { since: '', fast: false, pushRefs: false }, busy: busyType === t.type, onChange: function (patch) { return patchForm(t.type, patch); }, onRun: function () { return trigger(t.type); } }));
        })),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 } },
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '18px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('Recent runs')),
            activeExists && react_1.default.createElement(CircularProgress_1.default, { size: 14, thickness: 6, sx: { color: NAVY } })),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: { borderRadius: 2, backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.07)', overflow: 'hidden' } },
            react_1.default.createElement(Box_1.default, { sx: {
                    display: 'grid', gridTemplateColumns: '120px 110px 1fr 90px 130px 30px',
                    gap: 1, px: 1, py: '10px', backgroundColor: '#f6f6f9',
                    fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em',
                } },
                react_1.default.createElement(Box_1.default, null, (0, Lang_js_1.__)('Type')),
                react_1.default.createElement(Box_1.default, null, (0, Lang_js_1.__)('Status')),
                react_1.default.createElement(Box_1.default, null, (0, Lang_js_1.__)('By / Error')),
                react_1.default.createElement(Box_1.default, null, (0, Lang_js_1.__)('Duration')),
                react_1.default.createElement(Box_1.default, null, (0, Lang_js_1.__)('Started')),
                react_1.default.createElement(Box_1.default, null)),
            runs.length === 0 ? (react_1.default.createElement(Typography_1.default, { sx: { p: 3, textAlign: 'center', color: '#999', fontSize: '14px' } }, (0, Lang_js_1.__)('No sync runs yet.'))) : (runs.map(function (run) { return (react_1.default.createElement(RunRow, { key: run.id, run: run, expanded: expandedId === run.id, onToggle: function () { return setExpandedId(expandedId === run.id ? null : run.id); } })); })))));
};
var panelEl = document.getElementById('msia-admin-brightcove-sync-container');
if (panelEl) {
    (0, mountIsland_1.mountIsland)(panelEl, react_1.default.createElement(BrightcoveSyncPanel, null));
}
exports.default = BrightcoveSyncPanel;
